const Login = () => {
  return (
    <div>
      <h3>Login</h3>
    </div>
  );
};

export default Login;
